export default defineNuxtRouteMiddleware(async to => {
  const { $um } = useNuxtApp()

  if (!await $um.getUser()) {
    $um.signinRedirect()
    return abortNavigation("Redirecting to login...")
  }
})
